import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const UtilitiesService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getUtilityAccountBySearch = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);

    return axios.get(`${BASE_URL}/utilities-account/search${queryString}`, {
      headers,
    });
  };

  const getUtilityBillBySearch = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);

    return axios.get(`${BASE_URL}/utilities-account/bills/search${queryString}`, {
      headers,
    });
  };

  const getBeaufortBillByAccountId = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);

    return axios.get(`${BASE_URL}/utilities-account/beaufort/bills/search${queryString}`, {
      headers,
    });
  };

  const getEbillingsByAccountId = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);

    return axios.get(`${BASE_URL}/utilities-account/ebillings${queryString}`, {
      headers,
    });
  };

  const getBeaufortUnenrollmentsByDate = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/utilities-account/unenrollment/beaufort/date/${criteria}`, {
      headers,
    });
  };

  const setBeaufortUnenrollmentsByDate = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(
      `${BASE_URL}/utilities-account/unenrollment/beaufort/send`,
      { criteria, },
      { headers, }
    );
  };

  const getById = (serviceOfferingId, utilityAccountId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/accounts/${serviceOfferingId}/${utilityAccountId}`, { headers, });
  };

  const getByCustomerId = (serviceOfferingId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.get(`${BASE_URL}/accounts/${serviceOfferingId}/customer/${customerId}`, {
      headers,
    });
  };

  const linkAccountAndCustomer = (serviceOfferingId, utilityAccountId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/accounts/${serviceOfferingId}/${utilityAccountId}/link/${customerId}`,
      undefined,
      { headers, }
    );
  };

  const unlinkAccountAndCustomer = (serviceOfferingId, utilityAccountId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(
      `${BASE_URL}/accounts/${serviceOfferingId}/${utilityAccountId}/unlink/${customerId}`,
      { headers, }
    );
  };

  const batchPay = (
    serviceOfferingId,
    customerId,
    paymentAccountToken
  ) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/batchpay/${serviceOfferingId}`,
      { customerId, paymentAccountToken, },
      { headers, }
    );
  };

  const addAutopayToUtilityAccount = (
    serviceOfferingId,
    utilityAccountId,
    customerId,
    paymentAccountToken
  ) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(
      `${BASE_URL}/autopay/${serviceOfferingId}`,
      { utilityAccountId, customerId, paymentAccountToken, },
      { headers, }
    );
  };

  const removeAutopayFromUtilityAccount = (serviceOfferingId, autopayId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/autopay/${serviceOfferingId}/${autopayId}`, { headers, });
  };

  const disableEbillingForAccount = (serviceOfferingId, ebillingId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/accounts/${serviceOfferingId}/ebillings/${ebillingId}`, {
      headers,
    });
  };

  const applyChargeback = (chargebackTransactionId, serviceOfferingId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/bills/${serviceOfferingId}/${chargebackTransactionId}/chargeback`, {}, {
      headers,
    });
  };

  service.getUtilityAccountBySearch = getUtilityAccountBySearch;
  service.getUtilityBillBySearch = getUtilityBillBySearch;
  service.getBeaufortBillByAccountId = getBeaufortBillByAccountId;
  service.getBeaufortUnenrollmentsByDate = getBeaufortUnenrollmentsByDate;
  service.setBeaufortUnenrollmentsByDate = setBeaufortUnenrollmentsByDate;
  service.getById = getById;
  service.getByCustomerId = getByCustomerId;
  service.linkAccountAndCustomer = linkAccountAndCustomer;
  service.unlinkAccountAndCustomer = unlinkAccountAndCustomer;
  service.addAutopayToUtilityAccount = addAutopayToUtilityAccount;
  service.removeAutopayFromUtilityAccount = removeAutopayFromUtilityAccount;
  service.disableEbillingForAccount = disableEbillingForAccount;
  service.applyChargeback = applyChargeback;
  service.batchPay = batchPay;
  service.getEbillingsByAccountId = getEbillingsByAccountId;

  return service;
})();

export default UtilitiesService;
